import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell.js';
import { ProtectedRoute } from './components/ProtectedRoute.js';
import { AdminRoute } from './components/AdminRoute.js';
import { Spinner } from './components/Spinner.js';
import { LoginPage } from './pages/LoginPage.js';
import { SellPage } from './pages/SellPage.js';
import { CartPage } from './pages/CartPage.js';
import { TodayPage } from './pages/TodayPage.js';
import { AdminLayout } from './pages/admin/AdminLayout.js';
import { DashboardPage } from './pages/admin/DashboardPage.js';
import { ProductsListPage } from './pages/admin/ProductsListPage.js';
import { ProductFormPage } from './pages/admin/ProductFormPage.js';
import { CategoriesPage } from './pages/admin/CategoriesPage.js';
import { DiscountsListPage } from './pages/admin/DiscountsListPage.js';
import { DiscountRuleFormPage } from './pages/admin/DiscountRuleFormPage.js';
import { StockMovementsPage } from './pages/admin/StockMovementsPage.js';
import { SalesPage } from './pages/admin/SalesPage.js';
import { UsersPage } from './pages/admin/UsersPage.js';
import { SettingsPage } from './pages/admin/SettingsPage.js';

// Route-split: pulls in `qrcode` only when this page is actually visited.
const ScanSheetPage = lazy(() =>
  import('./pages/ScanSheetPage.js').then((m) => ({ default: m.ScanSheetPage })),
);

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route path="/sell" element={<SellPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/today" element={<TodayPage />} />

        <Route
          path="/admin"
          element={
            <AdminRoute>
              <AdminLayout />
            </AdminRoute>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="products" element={<ProductsListPage />} />
          <Route path="products/new" element={<ProductFormPage />} />
          <Route path="products/:id" element={<ProductFormPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="discounts" element={<DiscountsListPage />} />
          <Route path="discounts/new" element={<DiscountRuleFormPage />} />
          <Route path="discounts/:id" element={<DiscountRuleFormPage />} />
          <Route path="stock" element={<StockMovementsPage />} />
          <Route path="sales" element={<SalesPage />} />
          <Route path="users" element={<UsersPage />} />
          <Route path="settings" element={<SettingsPage />} />
          <Route
            path="scan-sheet"
            element={
              <Suspense fallback={<Spinner label="Loading scan sheet" />}>
                <ScanSheetPage />
              </Suspense>
            }
          />
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/sell" replace />} />
      <Route path="*" element={<Navigate to="/sell" replace />} />
    </Routes>
  );
}
